import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'
import Slider from 'front/components/Slider/Slider.js'

import './Project.css'
import templateBottom from './ProjectBottom.jinja'


var Project = BaseView.extend({
    events: {
       'click .Project-button': 'onOrderProjectClick'
    },
    initialize () {
        _.bindAll(this, 'openSlide', 'closeSlide', 'onOrderProjectClick')

        this.views = []

        _.each(this.$('.Slider'), (el) => {
            var $el = $(el)

            if ($el.find('.Slider-slide').length > 1) {
                this.views.push(new Slider({
                    el: $el,
                    type: 'project'
                }))
            }
        })

        this.$overlay = this.$('.Project-overlay')
        this.$top = this.$('.Project-top')
        this.$bottom = this.$('.Project-bottom')

        app.vent.on('ProjectSide-isOpening', this.openSlide)
        app.vent.on('ProjectSide-isClosing', this.closeSlide)
    },

    onOrderProjectClick() {
        app.views.applicationPopup.activate();
    },

    openSlide() {
        $.Velocity.animate(this.$overlay[0], {opacity: [0.8, 0]}, {display: 'block'})

        $.Velocity.animate([this.$top[0], this.$bottom[0]],
            {
                translateX: [350, 0],
                translateZ: 0
            }, {
                duration: 500,
                easing: 'easeOutQuad'
            })
    },

    closeSlide() {
        $.Velocity.animate(this.$overlay[0], {opacity: [0, 0.8]}, {display: 'none'})

        $.Velocity.animate([this.$top[0], this.$bottom[0]],
            {
                translateX: [0, 350],
                translateZ: 0
            }, {
                duration: 500,
                easing: 'easeOutQuad'
            })
    },

    refreshSliders() {
        _.each(this.views, (view) => {
            view.refresh()
        })
    }
})

export default Project


// WEBPACK FOOTER //
// ./assets/app/front/components/Project/Project.js